import { ArrowDownRight, ArrowRight } from "lucide-react";

const HERO_IMG =
  "https://customer-assets.emergentagent.com/job_timber-vision-2/artifacts/7qiaz971__DSC9362.jpg";

const Hero = () => {
  const stats = [
    { k: "100 %", v: "Holzanteil", d: "Keine Leime. Keine Fremdstoffe." },
    { k: "3×", v: "Bautempo", d: "Schneller als herkömmlicher Massivbau." },
    { k: "−75 %", v: "U-Wert", d: "Gegenüber der Referenzgruppe." },
    { k: "6×", v: "weniger CO₂-Ausstoss", d: "Im Vergleich zum Holzrahmenbau." },
  ];

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end pb-16 md:pb-24 pt-32 overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_IMG})` }}
        aria-hidden
      />
      <div
        className="absolute inset-0 bg-gradient-to-r from-[#050505]/95 via-black/55 to-black/25"
        aria-hidden
      />
      <div
        className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-[#050505]"
        aria-hidden
      />
      <div
        className="absolute inset-0 opacity-[0.08] pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.5) 1px, transparent 1px)",
          backgroundSize: "80px 80px",
        }}
        aria-hidden
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 w-full z-10">
        <div className="max-w-4xl mw-rise">
          <h1
            data-testid="hero-headline"
            className="font-heading text-5xl sm:text-6xl lg:text-7xl font-light leading-[1.02] tracking-tighter text-white"
          >
            Die Zukunft des Bauens ist{" "}
            <span className="italic font-extralight text-[#c88a53]">
              monolithisch.
            </span>
          </h1>

          <p
            data-testid="hero-subline"
            className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed font-light"
          >
            MONOWOOD — das ehrlichste Holzbausystem. Entwickelt für die
            Transformation einer Branche, die 40 % der globalen
            CO₂‑Emissionen verantwortet.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <a
              href="#kontakt"
              data-testid="hero-primary-cta"
              className="btn-primary text-sm"
            >
              Pitch Booklet anfordern
              <ArrowRight size={16} />
            </a>
            <a
              href="#vision"
              data-testid="hero-secondary-cta"
              className="btn-ghost text-sm"
            >
              Vision verstehen
              <ArrowDownRight size={16} />
            </a>
          </div>

          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10 max-w-4xl">
            {stats.map((s, i) => (
              <div
                key={i}
                data-testid={`hero-stat-${i}`}
                className="bg-[#050505] py-6 px-4"
              >
                <div className="font-heading text-2xl md:text-3xl text-white font-mono-num font-light">
                  {s.k}
                </div>
                <div className="text-[0.7rem] uppercase tracking-[0.2em] text-white/55 mt-2 font-semibold">
                  {s.v}
                </div>
                <div className="text-xs text-white/40 mt-1.5 leading-snug">
                  {s.d}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 right-6 md:bottom-10 md:right-12 text-[0.65rem] tracking-[0.3em] uppercase text-white/40 z-10 hidden md:block">
        01 — Hero
      </div>
    </section>
  );
};

export default Hero;
